import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { UsersService } from './services/users/users.service';
import { User } from './classes/user';
import { GlobalService } from './services/global/global.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { LoginPage } from './pages/auth/login/login.page';
import { UtilsService } from './services/utils/utils.service';
import { FcmService } from './services/fcm/fcm.service';
import { DetalleNovedadPage } from './pages/home/detalle-novedad/detalle-novedad.page';
import { Novedad } from './classes/novedad';
import { Router } from '@angular/router';
import { AppVersion } from '@ionic-native/app-version/ngx';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public selectedIndexFooter;
  public appPages = [
    {
      title: 'Inicio',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Servicio de retiro',
      url: '/servicio-retiro',
      icon: 'truck'
    },
    {
      title: 'Centro de canje',
      url: '/centro-canje',
      icon: 'percent'
    },
    {
      title: '¿Dónde llevar reciclables?',
      url: '/puntos-verdes',
      icon: 'map-marked-alt'
    },
    // {
    //   title: 'Estadisticas',
    //   url: '/estadisticas',
    //   icon: 'poll'
    // },
    // {
    //   title: 'Atención al Cliente',
    //   //url: '/api.whatsapp.com/send?phone=543515722408&text=Hola%20que%20tal',
    //   icon: 'map-marked-alt'
    // },
    // {
    //   title: 'Facebook',
    //   //url: '/api.whatsapp.com/send?phone=543515722408&text=Hola%20que%20tal',
    //   //icon: 'facebook'
    // },
    // {
    //   title: 'Instagram',
    //   //url: '/api.whatsapp.com/send?phone=543515722408&text=Hola%20que%20tal',
    //   //icon: 'instagram'
    // },
  ];
  public footerPages= []
  public contacto={
      title: 'Contacto',
      url: '/contacto',
      icon: 'info-circle'
    };
  micuenta={
    title: 'Mi cuenta',
    url: '/mi-cuenta',
    icon: 'user-circle'
  };
  mibilletera={
    title: 'Mi Billetera',
    url: '/mywallet',
    icon: 'wallet'
  };
  reciclados={
    title: 'Mis Historial de Reciclados',
    url: '/reciclados',
    icon: 'recycle'
  };
  user=new User;
  islogged=false;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private db:AngularFirestore,
    private global:GlobalService,
    private utils:UtilsService,
    private fcmSrv:FcmService,
    private router:Router,
    private appVersion: AppVersion
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if(this.platform.is("cordova")){
        if(this.platform.is("android")){
          console.log(this.appVersion.getVersionNumber());
        }
        this.fcmSettings();
        FCM.onNotification().subscribe(data => {
          console.log(data);
          if(data.goto){
            this.router.navigateByUrl(data.data.goto);
          }
          if(data.data){
            let novedad=new Novedad;
            novedad.titulo=data.data.titulo;
            novedad.descripcion=data.data.descripcion;
            novedad.imagen=data.data.imagen;
            this.utils.edcModal(DetalleNovedadPage, novedad,);
          }
        });
      }

    });
  }

  ngOnInit() {
    this.global.uid_value.subscribe(uid=>{
      if(uid && uid!=""){
        this.db.collection("users").doc(uid).valueChanges().subscribe((user:User)=>{
          if(user){
            this.appPages=this.utils.analizarDuplicadosByUrl(this.reciclados, this.appPages);
            this.user=user;
            this.global.role=user.datos.role;
            this.islogged=true;
            this.footerPages=[this.mibilletera,this.micuenta,this.contacto]
          }else{
            this.footerPages=[this.contacto]    
          }
        });
      }else{
        if(this.appPages.indexOf(this.reciclados)!=-1){
          this.appPages.splice(this.appPages.indexOf(this.reciclados),1);
        }
        this.islogged=false;
        this.footerPages=[this.contacto]
      }
    })
  }
  iniciarsesion(){
    this.utils.edcModal(LoginPage, "");
  }
  registerEcorecolector(){
    window.open("https://api.whatsapp.com/send?phone=5493515722408&text=Hola%20que%20tal");
  }
  registerComercio(){
    window.open("https://play.google.com/store/apps/details?id=docta.eco.aliado");
  }
  fcmSettings(){
    if(this.platform.is("cordova")){
      this.global.uid_value.subscribe(uid=>{
        if(uid&&uid!=''){
          this.fcmSrv.getToken().then(()=>{
            this.fcmSrv.subscribeToTopic("users");
            this.fcmSrv.suscribeOnNotifications();
          });
        }
      })
    }
  }
  
}
